import { Manager } from './core/Manager';
import { BaseGameScene } from "./scene/BaseGameScene";
//import { GameScene } from "./scene/GameScene";

(async () => {
    await Manager.initialize("#000000");

    console.log("after initialize");
    //new GameScene(); 
    const game = new BaseGameScene();
    await Manager.changeScene(game, true);

})();